import { useMemo, useState } from "react";
import VirtualizedTable from "../components/VirtualizeTable";
import AdminsDelete from "./AdminsDelete";
import AdminsUpdate from "./AdminsUpdate";
import { formatPhone } from "../helpers/format";
import { MRT_ColumnDef } from "material-react-table";
import { IconEdit, IconTrash } from "@tabler/icons-react";

const AdminsTableComponent = ({
  data,
  refetch,
}: {
  data: Array<{
    id: string;
    name: string;
    phone: string;
    createdAt: string | Date;
    status: string;
  }>;
  refetch: () => void;
}) => {
  const [deleteAlert, setDeleteAlert] = useState(false);
  const [edit, setEdit] = useState(false);
  const [value, setValue] = useState(data[0] || {});
  const [id, setId] = useState("");

  const columns = useMemo<MRT_ColumnDef<(typeof data)[0]>[]>(() => {
    return [
      {
        accessorKey: "name",
        header: "Nome",
      },
      {
        accessorKey: "phone",
        header: "Telefone",
        Cell: ({ cell }) => formatPhone(cell.getValue() as string),
      },
      {
        accessorKey: "status",
        header: "Status",
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
        enableSorting: false,
        enableColumnActions: false,
        Cell: ({ cell }) => {
          const status = cell.getValue() as string;
          let label = "";
          let color = "";

          switch (status) {
            case "REGISTERED":
              label = "Registrado";
              color = "#2e7d32";
              break;
            case "PENDING":
              label = "Pendente";
              color = "#fbc02d";
              break;
            case "DISABLED":
              label = "Bloqueado";
              color = "#d32f2f";
              break;
            default:
              label = "-";
              color = "gray";
          }

          return (
            <div
              style={{
                padding: "4px 12px",
                borderRadius: "12px",
                backgroundColor: color,
                color: "#fff",
                fontWeight: 600,
                fontSize: "0.75rem",
                textAlign: "center",
                display: "inline-block",
                minWidth: "100px",
              }}
            >
              {label}
            </div>
          );
        },
      },
      {
        id: "edit",
        header: "Editar",
        size: 50,
        Cell: ({ row }: any) => (
          <IconEdit
            onClick={() => {
              setEdit(true);
              setValue(row.original);
            }}
            style={{ cursor: "pointer", color: "#FFF" }}
          />
        ),
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
        enableSorting: false,
        enableColumnActions: false,
      },
      {
        id: "delete",
        header: "Excluir",
        size: 50,
        Cell: ({ row }: any) => (
          <IconTrash
            onClick={() => {
              setId(row.original.id);
              setDeleteAlert(true);
            }}
            style={{ cursor: "pointer", color: "#d32f2f" }}
          />
        ),
        muiTableHeadCellProps: { align: "center", sx: { textAlign: "center" } },
        muiTableBodyCellProps: { align: "center", sx: { textAlign: "center" } },
        enableSorting: false,
        enableColumnActions: false,
      },
    ];
  }, [data]);

  return (
    <>
      <VirtualizedTable
        data={data}
        columns={columns}
        fetchNextPage={() => Promise.resolve()}
        isLoading={false}
      />

      <AdminsDelete
        open={deleteAlert}
        onClose={() => setDeleteAlert(false)}
        id={id}
        onAction={refetch}
      />
      <AdminsUpdate
        open={edit}
        onClose={() => setEdit(false)}
        item={value}
        refetch={refetch}
      />
    </>
  );
};

export default AdminsTableComponent;
